import { loadStripe } from '@stripe/stripe-js';
import supabase from '../supabase/supabase';

const stripePublicKey = import.meta.env.VITE_STRIPE_PUBLISHABLE_KEY;
let stripePromise;

export const getStripe = () => {
  if (!stripePromise && stripePublicKey && !stripePublicKey.includes('_YOUR_')) {
    stripePromise = loadStripe(stripePublicKey);
  }
  return stripePromise;
};

export const handleStripeCheckout = async (options) => {
  const config = typeof options === 'string' ? { priceId: options } : options;
  const { priceId, metadata = {} } = config;

  if (!priceId || priceId.includes('YOUR_')) {
    throw new Error("Stripe Price ID is missing in your .env file.");
  }

  const { data: { session } } = await supabase.auth.getSession();

  try {
    console.log("Attempting to invoke Edge Function: create-checkout");
    
    const { data, error } = await supabase.functions.invoke('create-checkout', {
      body: {
        priceId,
        customerEmail: session?.user?.email,
        metadata: {
          ...metadata,
          user_id: session?.user?.id || 'guest',
        },
        successUrl: `${window.location.origin}/#/checkout-success`,
        cancelUrl: `${window.location.origin}/#/checkout-cancel`,
      },
    });

    if (error) {
      console.error("Function returned an error:", error);
      throw error;
    }

    if (data?.url) {
      window.location.href = data.url;
    } else {
      throw new Error("The server didn't return a checkout URL. Check your Stripe Secret Key in Supabase Secrets.");
    }
    
  } catch (err) {
    console.error("Full Connection Error Object:", err);
    
    // This specific error means the function isn't "uploaded" to the new project yet
    if (err.message?.includes('404') || err.name === 'FunctionsHttpError') {
      throw new Error(
        "CRITICAL: The 'create-checkout' function is missing from your NEW Supabase project. " +
        "You must run 'supabase functions deploy create-checkout' from your local terminal to upload the code."
      );
    }
    
    throw err;
  }
};